import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./custom-slice";

export const apiSlice = createApi({
	reducerPath: "apiSlice",
	baseQuery: customBaseQuery,
	tagTypes: [
		"CustomerDashboard",
		"SolarProviderInformation",
		"SolarProducts",
		"Orders",
		"CustomerOrders",
		"Transactions",
		"CustomerInfo",
		"ProductCategory",
		"RoofTypes",
		"Wishlist",
		"DeliveryAddress",
		"CustomerCards",
		"ApplianceCategory",
		"BpsAdminDashboard",
		"BpsAdminDashboardChart",
		"LoanSummary",
		"PaymentPlans",
		"ElectricDistributionCompanies",
		"Leads",
		"Leads-Recommended-Products",
		"Recommendation-Request",
		"Recommendation-Requests",
		"Utility",
		"Utilities",
		"VendingUtilities",
		"LoanRequest",
		"UtilityUsers",
		"Roles",
		"Transaction",
		"Refunds",
		"Refund",
		"AuditLogs",
		"UtilAdminUtility",
		"ServiceRequests",
		"ServiceRequestInstances",
		"ServiceRequestInstance",
		"Workflows",
		"BulkPurchases",
		"WalletBalance",
		"RepaymentLoan",
		"EnergyAccount",
		"MeterConsumption",
		"ConsumptionGraph",
		"Departments",
		"UtilityStaffUsers",
		"QuickServiceRequest",
		"RecentServiceRequest",
		"StepInstance",
		"UserDepartments",
		"SupervisorSteps",
		"TeamMembers",
		"UserProfile",
		"Notifications",
		"StaffReferral",
		"EnergyAlerts",
		"Beneficiaries",
		"BroadcastNotifications",
		"BroadcastNotificationDetail",
		"ReconcilliationHistory",
		"UtilityConfigurations",
		"EmailTemplateConfiguration",
		"UtilityApiKeys",
		"SafetyStaffInsighst",
	],
	endpoints: builder => ({}),
});
